import styled from 'styled-components';
import {
  SectionParent,
  BlueButtonA,
} from '../../../components/StyledComponents';
import React from 'react';
import { Link, navigate } from 'gatsby';

const Section = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #ffffff;
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const Heading = styled.div`
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #755dbf;
  text-align: center;
  padding-bottom: 2rem;
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

const SubHeading = styled.div`
  font-size: 21px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;
  padding-bottom: 1rem;
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 85%;
  grid-gap: 2rem;
  padding: 3rem 0;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const Card = styled(Link)`
  display: grid;
  grid-column: span 1;
  border-radius: 8px;
  box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.15);
  background-color: #ffffff;
  cursor: pointer;
  :hover {
    transform: scale(1.05);
  }
  @media (max-width: 520px) {
    grid-column: span 3;
  }
`;

const CardTop = styled.div`
  height: 15px;
  border-radius: 8px 8px 0 0;
  background-color: #323f6d;
`;

const CardTopPurple = styled(CardTop)`
  background-color: none;
  background-image: linear-gradient(to left, #735dbe, #9a6ad3 2%);
`;

const CardTextSection = styled.div`
  padding: 3rem;
  display: grid;
  justify-content: center;
  @media (max-width: 800px) {
    padding: 1.5rem;
  }
`;

const CardHeader = styled.div`
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #151828;
  text-align: center;
  @media (max-width: 800px) {
    font-size: 21px;
  }
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;

const CardSubHeader = styled.div`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;
  padding-bottom: 1rem;
  @media (max-width: 800px) {
    min-height: 4rem;
    font-size: 14px;
  }
  @media (max-width: 520px) {
    font-size: 18px;
    min-height: 0;
  }
`;

const FreeText = styled.div`
  font-size: 21px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;
  text-align: center;
  @media (max-width: 520px) {
    font-size: 21px;
  }
`;

const GreenBox = styled.div`
  padding: 1rem 2rem;
  border: solid 1px #0a654a;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #0a654a;
  width: 50%;
  margin-top: 1.5rem;
  @media (max-width: 800px) {
    width: 80%;
  }
`;

const BlueButtonNew = styled(BlueButtonA)`
  margin-top: 2rem;
  height: auto;
  text-align: center;
`;

export default class ProductSectionFive extends React.Component<any, any> {
  render() {
    return (
      <Section>
        <Heading>{this.props?.messages?.HomePagePricingTitle}</Heading>
        <SubHeading>{this.props?.messages?.HomePagePricingDesc}</SubHeading>
        <CardContainer>
          <Card to={'/pricing'}>
            <CardTop />
            <CardTextSection>
              <CardHeader>
                {this.props?.messages?.HomePagePricingStarter}
              </CardHeader>
              <CardSubHeader>
                {this.props?.messages?.HomePagePricingStarterFor}
              </CardSubHeader>
              <FreeText>
                {this.props?.messages?.HomePagePricingStarterFree} <br />
                {this.props?.messages?.HomePagePricingStarter100Devices}
              </FreeText>
            </CardTextSection>
          </Card>
          <Card to={'/pricing'}>
            <CardTop />
            <CardTextSection>
              <CardHeader>
                {this.props?.messages?.HomePagePricingEssentials}
              </CardHeader>
              <CardSubHeader>
                {this.props?.messages?.HomePagePricingEssentialsFor}
              </CardSubHeader>
              <FreeText>
                {this.props?.messages?.HomePagePricingEssentialsMin100Devics}
                <br />
                {this.props?.messages?.HomePagePricingBilledAnnually}
              </FreeText>
            </CardTextSection>
          </Card>
          <Card to={'/pricing'}>
            <CardTopPurple />
            <CardTextSection>
              <CardHeader>
                {this.props?.messages?.HomePagePricingPro}
              </CardHeader>
              <CardSubHeader>
                {this.props?.messages?.HomePagePricingProFor}
              </CardSubHeader>
              <FreeText>
                {this.props?.messages?.HomePagePricingProMin1000Devices} <br />
                {this.props?.messages?.HomePagePricingBilledAnnually}
              </FreeText>
            </CardTextSection>
          </Card>
        </CardContainer>
        <GreenBox>
          {this.props?.messages?.HomePagePricingOnSiteDeployment}
        </GreenBox>
        <BlueButtonNew
          id="product_get_more_info_pricing"
          to={
            this.props.messages?.locale !== 'en'
              ? `/${this.props.messages?.locale}/pricing`
              : '/pricing'
          }
        >
          {this.props?.messages?.HomePagePricingCTA}
        </BlueButtonNew>
      </Section>
    );
  }
}
